import { Typography, Fade, Divider } from "@mui/material"
import { Fragment, ReactElement } from "react"

import { NAV_ICON_SX } from "./navBarWrapper"
import NavButtonVerticalExpanded from "./navButtons/navButtonVerticalExpanded"
import { NAV_FADE_TIME_MS } from "../../../constants/generalConstants"
import { NavOptionType } from "../navOptions"

interface ExpandedOptionsProps {
    groups: string[]
    options: NavOptionType[]
    onClickSideEffect?: () => void
}

/** Renders vertical nav bar options and groups */
const ExpandedVerticalNavOptions = ({
    groups,
    options,
    onClickSideEffect,
}: ExpandedOptionsProps): ReactElement => (
    <>
        {groups.map((groupName: string) => (
            <Fragment key={`NavVerticalExpandGroup${groupName}`}>
                <Fade in timeout={NAV_FADE_TIME_MS}>
                    <Typography
                        key={groupName}
                        fontWeight="500"
                        marginTop={1}
                        marginBottom={1}
                        color="text.secondary"
                        paddingX={1}
                    >
                        {groupName}
                    </Typography>
                </Fade>
                {options.map(
                    (option: NavOptionType) =>
                        option.group === groupName && (
                            <NavButtonVerticalExpanded
                                key={`NavVerticalExpandSub${
                                    groupName + option.name
                                }`}
                                title={option.name}
                                route={option.route}
                                icon={<option.icon sx={NAV_ICON_SX} />}
                                onClickSideEffect={onClickSideEffect}
                                external={option?.external}
                            />
                        )
                )}
                <Divider sx={{ marginTop: 3, marginBottom: 2 }} light />
            </Fragment>
        ))}
    </>
)

ExpandedVerticalNavOptions.defaultProps = {
    onClickSideEffect: undefined,
}

export default ExpandedVerticalNavOptions
